import React from 'react';

import Header from 'components/Header/HeaderApp';
import PageTitle from 'components/_base/PageTitle';
import Bottom from 'components/Bottom';
import ContentBancoArtes from './ContentBancoArtes';

const BancoArtes = () => {
  return (
    <>
      <Header />
      <div className="panel">
        <PageTitle title="Banco de Artes" />
        <hr />
        <ContentBancoArtes style={{ minHeight: '100%' }} />
      </div>
      <Bottom style={{ bottom: '0', position: 'absolute' }} />
    </>
  );
};

export default BancoArtes;
